<app-public-content>
    <div class="bg-surface-0 dark:bg-surface-900 p-8 md:p-12 shadow-sm rounded-2xl w-full max-w-xl mx-auto flex flex-col gap-8 text-center">
        <app-public-branding></app-public-branding>

        <div class="mb-4">
            <h2 class="text-6xl font-bold text-surface-900 dark:text-surface-100 mb-2">
                403
            </h2>
            <h3 class="text-2xl font-semibold text-surface-700 dark:text-surface-300">
                Page Not Allowed
            </h3>
        </div>

        <p class="text-surface-600 dark:text-surface-400 leading-relaxed mb-3">
            Sorry, the page or resource you are attempting to access is not allowed.  
            Please navigate back and try again.
        </p>

        <div class="flex flex-col gap-3 w-full">
            <button
                pButton
                type="button"
                class="w-full py-2 rounded-lg flex justify-center items-center"
                severity="primary"
                (click)="navigateHome()">
                <i class="pi pi-home" pButtonIcon></i>
                <span pButtonLabel>Home</span>
            </button>

            <button
                pButton
                type="button"
                class="w-full py-2 rounded-lg flex justify-center items-center"
                severity="secondary"
                (click)="navigateBack()">
                <i class="pi pi-arrow-left" pButtonIcon></i>
                <span pButtonLabel>Back</span>
            </button>
        </div>
    </div>
</app-public-content>